export default ['Resty', 'SectorDataLoader', (Resty, SectorDataLoader) => {
  return Resty('alarm_sectors', klass => {
    Object.assign(klass, {
      getFormData(id) {
        return SectorDataLoader('alarm', id ? klass.fetchOne(id) : null);
      }
    });
  });
}];
